require('./aresUserFallbackView.scss');

// @ vendors
const React = require('react');

// @ components
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKCover } = require('commonsComponents/OKCover');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const aresUserConstants = require('constants/aresUser');

class AresUserFallbackView extends React.Component {
    render() {
        const redirectLink = aresUserConstants.LOANS_ARES_URL;
        const poeditorPrefix = 'nerudaUserFallbackView';

        const secondaryButton = (
            <div className="neruda-user-fallback-view__main-button">
                <OKButton
                    id="mainButton"
                    leftIcon="icon-anterior"
                    modifier="link-emphasize"
                    to={redirectLink}
                >
                    VOLVER A PRESTAMOS
                </OKButton>
            </div>
        );

        const mainButton = (
            <div className="neruda-user-fallback-view__secondary-button">
                <OKButton
                    id="secondaryButton"
                    modifier="primary"
                    to="/myprofile/accounts"
                >
                    <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_mainButton`} />
                </OKButton>
            </div>
        );

        return (
            <div className="ares-user-fallback-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="cards" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={[]}
                            />
                        </OKCover>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-10 col-xs-offset-1">
                                    <div className="neruda-user-fallback-view__main-content">
                                        <div className="neruda-user-fallback-view__highlight">
                                            <i className={`neruda-user-fallback-view__icon neruda-user-fallback-view__info-icon`} >
                                            </i>
                                            <div className="neruda-user-fallback-view__messages">
                                                <OKBoxTitle value={formatText(`${poeditorPrefix}-${poeditorPrefix}_title`)}/>
                                            </div>
                                        </div>
                                        <div className="neruda-user-fallback-view__content">
                                            <p className="neruda-user-fallback-view__message">
                                                <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_mainText`} />
                                            </p>
                                        </div>
                                        <div className="neruda-user-fallback-view__footer">
                                            <div className="neruda-user-fallback-view__separator" />
                                            <div className="neruda-user-fallback-view__footer-buttons">
                                                {mainButton} {secondaryButton} 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

module.exports = AresUserFallbackView;
